import {Box} from "@mui/system";
import ButtonAdd from "./ButtonAdd";
import {Divider} from "@mui/material";
import {alpha} from '@mui/material/styles';

const ButtonWidthDivider = ({text, width, onClick, buttonSx, sx}) => {
    return <Box sx={{
        display: 'flex',
        alignItems: 'center',
        position: "relative",
        '&:hover .child-box': {
            width: '50px',
            height: '50px',
            right: '-25px'
        },
        ...sx,
    }}>
        <ButtonAdd
            text={text} width={width} minWidth={width}
            onClick={onClick}
            fontSize={"22px"}
            sx={buttonSx}
        />
        <Divider sx={{bgcolor: (theme) => theme.palette.secondary.add, width: "80px"}}/>
        <Box className="child-box"
             sx={{
                 bgcolor: (theme) => alpha(theme.palette.secondary.add, 0.3),
                 width: "28px",
                 height: "28px",
                 borderRadius: "50%",
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 position: "absolute",
                 right: "-15px"
             }}>
            <Box sx={{
                bgcolor: (theme) => theme.palette.secondary.add,
                width: "7px",
                height: "7px",
                borderRadius: "7px",
            }}/>
        </Box>
    </Box>
}
export default ButtonWidthDivider